import LoadIconByName, { IconComponentType } from './helper/loadIconByName';

export default function GetIconByName(name: string, defaultValue?: IconComponentType) {
	return LoadIconByName(name, 32, n => require(`@bimser/icons/32/${n}.js`).default, defaultValue);
}
